import { render, staticRenderFns } from "./table-row.vue?vue&type=template&id=4e4537e1&scoped=true"
import script from "./table-row.vue?vue&type=script&lang=ts"
export * from "./table-row.vue?vue&type=script&lang=ts"
import style0 from "./table-row.vue?vue&type=style&index=0&id=4e4537e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4537e1",
  null
  
)

export default component.exports